var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('appointment-reminder-view',{attrs:{"show":_vm.show,"user":_vm.userData,"start-time":_vm.startTime,"is-offline":_vm.isOfflineAppointment}})}
var staticRenderFns = []

export { render, staticRenderFns }